import { render, staticRenderFns } from "./BillListItem.vue?vue&type=template&id=6bf90c2c&scoped=true&"
import script from "./BillListItem.vue?vue&type=script&lang=js&"
export * from "./BillListItem.vue?vue&type=script&lang=js&"
import style0 from "./BillListItem.vue?vue&type=style&index=0&id=6bf90c2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf90c2c",
  null
  
)

export default component.exports